/** Calendar validity helpers for the date tools. */

const DAY_TOKEN_REGEX = /(?<!\d)\d{1,2}(?!\d)/g;

export function daysInCalendarMonth(year: number, month: number): number {
  // Day 0 of the next month is this month's last day; setUTCFullYear keeps years 0-99.
  const date = new Date(0);
  date.setUTCFullYear(year, month, 0);
  return date.getUTCDate();
}

/** True when year-month-day names a day that exists (no 31 February, no 29 February 2026). */
export function isRealCalendarDate(
  year: number,
  month: number,
  day: number
): boolean {
  if (month < 1 || month > 12 || day < 1) {
    return false;
  }
  return day <= daysInCalendarMonth(year, month);
}

/**
 * `new Date("February 31, 2026")` rolls over to 3 March instead of failing. When the text
 * names a day-sized number but the parsed day is none of them, the parser rolled over, so
 * the typed date does not exist. Text with a clock time is left alone: converting its zone
 * can legitimately move the day.
 */
export function parsedDayMatchesText(text: string, parsedDay: number): boolean {
  if (text.includes(":")) {
    return true;
  }
  const tokens = text.match(DAY_TOKEN_REGEX);
  if (tokens === null) {
    return true;
  }
  return tokens.some((token) => Number.parseInt(token, 10) === parsedDay);
}
